module.exports = __webpack_public_path__ + "img/download.5270c28d.svg";